import bcrypt from 'bcryptjs';

// Password validation rules
export const validatePassword = (password: string): string[] => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('At least 8 characters');
  }
  
  if (!/(?=.*[a-z])/.test(password)) {
    errors.push('At least one lowercase letter');
  }
  
  if (!/(?=.*[A-Z])/.test(password)) {
    errors.push('At least one uppercase letter');
  }
  
  if (!/(?=.*\d)/.test(password)) {
    errors.push('At least one number');
  }
  
  if (!/(?=.*[@$!%*?&])/.test(password)) {
    errors.push('At least one special character (@$!%*?&)');
  }
  
  return errors;
};

// Hash password with bcrypt
export const hashPassword = async (password: string): Promise<string> => {
  const saltRounds = 12; // Industry standard
  return await bcrypt.hash(password, saltRounds);
};

// Verify password against hash
export const verifyPassword = async (password: string, hash: string): Promise<boolean> => {
  try {
    return await bcrypt.compare(password, hash);
  } catch (error) {
    // Always return false on error to prevent timing attacks
    console.error('Password verification error:', error);
    return false;
  }
};

// Generate secure random password
export const generateSecurePassword = (length: number = 16): string => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$!%*?&';
  let password = '';
  
  // Ensure at least one character from each required category
  password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; // lowercase
  password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]; // uppercase
  password += '0123456789'[Math.floor(Math.random() * 10)]; // number
  password += '@$!%*?&'[Math.floor(Math.random() * 7)]; // special
  
  // Fill the rest randomly
  for (let i = 4; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)];
  }
  
  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
}; 